import { render, staticRenderFns } from "./SharePage.vue?vue&type=template&id=19f146f5&scoped=true"
import script from "./SharePage.vue?vue&type=script&lang=ts"
export * from "./SharePage.vue?vue&type=script&lang=ts"
import style0 from "./SharePage.vue?vue&type=style&index=0&id=19f146f5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f146f5",
  null
  
)

export default component.exports